import { MMButton } from '@components'
import cn from 'classnames'
import { paths } from 'mmfintech-backend-api'
import { GlobalContext, tr } from 'mmfintech-commons'
import { useContext } from 'react'
import { useHistory } from 'react-router-dom'

import styles from './LoginRequiredModalContent.module.scss'

const LoginRequiredModalContent = () => {
  const { modalHide } = useContext(GlobalContext)
  const history = useHistory()

  function handleGoToLogin() {
    modalHide()
    history.push(paths.login())
  }

  return (
    <div>
      <p className={cn(styles['login-required-modal-message'])}>
        {tr(
          'FRONTEND.SUPPORT.LOGIN_REQUIRED.MESSAGE',
          'You need to log in to your account to contact customer service.'
        )}
      </p>
      <div className={cn(styles['login-required-modal-actions'])}>
        <MMButton
          size='large'
          variant='primary'
          fullWidth
          caption={tr('FRONTEND.SUPPORT.LOGIN_REQUIRED.GO_TO_LOGIN', 'Go to log in')}
          onClick={handleGoToLogin}
        />
        <MMButton
          size='large'
          variant='tertiary'
          className={cn(styles['login-required-modal-cancel'])}
          caption={tr('FRONTEND.SUPPORT.LOGIN_REQUIRED.CANCEL', 'Cancel')}
          onClick={modalHide}
        />
      </div>
    </div>
  )
}

export default LoginRequiredModalContent
